import { Typography, Container } from '@mui/material';
import classes from './TextContent.module.css';
import React from 'react';

const TextContent = props => {
    return (
        <section className={classes.section} style={{...props.sectionStyle}} data-aos={props['data-aos']}>
            <Container maxWidth={props.maxWidth || 'lg'} component="div" >
                <div style={{...props.sx}}>
                    {props.title && <Typography variant={ props.variant ? props.variant : "pageTitle"} component="h3" textAlign="center" style={{...props.styleTitle}}>{props.title}</Typography>}
                    {props.children}
                </div>
            </Container>

        </section>
    )
}

export default TextContent;